/**
 * Review + AggregateRating structured data (JSON-LD) for the /reviews page.
 *
 * Marks up the actual on-page testimonials so they are eligible for review
 * rich results. The aggregate is derived from the same data the page renders,
 * so the markup always reflects the genuine reviews shown to users.
 */

import { config } from '@/lib/config';
import { testimonials, REVIEW_COUNT, REVIEW_AGGREGATE_RATING } from '@/lib/seo/reviews-data';
import { JSONLDScript } from './jsonld-script';

export function ReviewStructuredData() {
  const baseUrl = config.appUrl;

  const reviewSchema = {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: 'Email Ferret',
    applicationCategory: 'EmailApplication',
    operatingSystem: 'Web',
    url: baseUrl,
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: REVIEW_AGGREGATE_RATING,
      reviewCount: REVIEW_COUNT,
      bestRating: 5,
      worstRating: 1,
    },
    review: testimonials.map((testimonial) => ({
      '@type': 'Review',
      reviewRating: {
        '@type': 'Rating',
        ratingValue: testimonial.rating,
        bestRating: 5,
        worstRating: 1,
      },
      author: {
        '@type': 'Person',
        name: testimonial.name,
      },
      reviewBody: testimonial.content,
    })),
  };

  return <JSONLDScript data={reviewSchema} id="review-structured-data" />;
}
